import { RouteObject } from "react-router-dom";
import { NotFound } from "src/routes/NotFound";
import { ConstraintItemCatalogPage } from "src/routes/libraries/task-catalog/ConstraintItemCatalogPage";
import { TaskCatalogLaborCostsPage } from "src/routes/libraries/task-catalog/TaskCatalogLaborCostsPage";
import { TaskCatalogPage } from "src/routes/libraries/task-catalog/TaskCatalogPage";
import { AppShell } from "src/routing/components/AppShell";
import { GlobalNavLayout } from "src/routing/components/layouts/GlobalNavLayout";
import { ScrollableParentLayout } from "src/routing/components/layouts/ScrollableParentLayout";
import { TaskCatalogSegmentPage } from "src/routing/domains/libraries/task-catalog/TaskCatalogSegmentPage";
import * as taskCatalogPaths from "src/routing/domains/libraries/task-catalog/taskCatalogPaths";

/**
 * `/libraries/task-catalog/*` route tree.
 *
 * Role: data router domain route.
 *
 * Stack: `AppShell` → `GlobalNavLayout` → `ScrollableParentLayout` → page (legacy `PageHeader` chrome).
 *
 * Order: index → constraint catalog (static) → labor costs → single-segment leaf.
 *
 * Collision: legacy registered both `TaskCatalogForm` (`:idOrAdd`) and `TaskCatalogPage` (`:folderId`)
 * for the same URL shape. RR6 can only mount one route, so `TaskCatalogSegmentPage` disambiguates
 * folder segments (team codes / tag ids) vs form segments (`add` / task ids).
 * `catalogTaskFolderRoute` remains in paths for URL builders; it is not a separate route leaf.
 */
export const taskCatalogRoutes: RouteObject = {
  path: taskCatalogPaths.catalogTasksRoute.path,
  Component: AppShell,
  children: [
    {
      Component: GlobalNavLayout,
      children: [
        {
          Component: ScrollableParentLayout,
          children: [
            { index: true, Component: TaskCatalogPage },
            { path: taskCatalogPaths.constraintItemsCatalogRoute.path, Component: ConstraintItemCatalogPage },
            { path: taskCatalogPaths.catalogTaskLaborCostsRoute.path, Component: TaskCatalogLaborCostsPage },
            { path: taskCatalogPaths.catalogTaskRoute.path, Component: TaskCatalogSegmentPage },
          ],
        },
      ],
    },
    { path: "*", Component: NotFound },
  ],
};
